import React, { Component, useEffect, useState } from 'react';
import { delete_cookie, read_cookie } from 'sfcookies';
import { Routes as Switch, Route } from 'react-router-dom';
import Login from './login/Login';
import MainSection from './main/MainSection';
import 'react-datepicker/dist/react-datepicker.css';
import AccountRecovery from './login/account_recovery';
import ResetPassword from './login/reset_password';
import { ToastContainer } from 'react-toastify';
import { SocketContext, socket } from './utiles/context/socket-context';

console.log(process.env.REACT_APP_ENVIROMENT);
console.log(process.env.REACT_APP_BASE_URL);

interface StateProps {
    logged: number
}

function App() {

    const [state, updateState] = useState<StateProps>({ logged: 0 })

    useEffect(() => {
        if (read_cookie('admin_pppcalc').length > 0) {
            updateState({ logged: 1 })
        } else {
            updateState({ logged: 2 })
        }
    }, [])

    const validateLogin = (tokenServer: string) => {
        if (tokenServer.length > 0) {
            updateState({
                logged: 1
            });
            window.history.replaceState('', '', '/');
            window.location.reload();
        } else {
            updateState({
                logged: 2,
            });
        }
    };

    const logOut = () => {
        delete_cookie('admin_pppcalc');
        window.history.replaceState('', '', '/');
        window.location.reload();
    };

    return (<>
        {
            state.logged == 1 ? (
                <SocketContext.Provider value={socket}>
                    <MainSection logOut={logOut} isLogged={true} />
                    <ToastContainer
                        position="top-right"
                        autoClose={process.env.REACT_APP_ENVIROMENT !== 'Production' ? 500 : 5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                    />
                </SocketContext.Provider>
            ) :
                state.logged == 2 && (
                    <div className='container'>
                        <div className="row">
                            <div className="offset-4 col-md-4">
                                <Switch>
                                    <Route path="/" element={<Login />} />
                                    <Route path="/forget-password" element={<AccountRecovery />} />
                                    <Route path="/reset-password" element={<ResetPassword />} />
                                    <Route path="*" element={<Login />} />
                                </Switch>
                            </div>
                        </div>
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="colored"
                        />
                    </div>
                ) || (<></>)
        }
    </>)
}

export default App;
